"use strict";

import "./SummaryCard.css";
import React from "react";
import classnames from "classnames";
import lang from "vwa/lang";
import Card from "vwa/components/Card";
import Pin from "vwa/components/Pin";

export default class SummaryCard extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			expanded: false
		};
	}
	
	toggle() {
		this.setState({
			expanded: !this.state.expanded
		});
	}
	
	handleAddressClick(evt, time) {
		evt.stopPropagation();
		this.props.onAddressClick(time);
	}
	
	handleDataClick(evt, which) {
		evt.stopPropagation();
		this.props.onFixData(which)
	}
	
	isDisplayedData(which) {
		return this.props.fixedData.includes(which) || this.state.expanded;
	}
	
	areDisplayedAnyData() {
		return this.props.fixedData.length > 0;
	}
	
	isBodyShown() {
		return this.state.expanded || this.areDisplayedAnyData()
	}
	
	getRowDataClassName(which) {
		return classnames(
			{"Hidden": !this.isDisplayedData(which)},
			{"Fixed": this.props.fixedData.includes(which)}
		);
	}
	
	renderCardHeader() {
		return (
			<header>
				<h1 className="POIName">{this.props.isSummaryOfSummaries ? lang.SUMMARY_FOR + " " + this.props.summary.poiCount + " " + lang.POIS : this.props.summary.poi}</h1>
				<div className="RightContainer">
					<div className="EmphasizedData">
						<label>{this.props.isSummaryOfSummaries ? this.props.summary.timeDiff : this.props.summary.timeDiff.sum}</label>
					</div>
					<div className="PinContainer">
						<Pin
							checked={this.props.pinned}
							indeterminate={!this.props.pinnedAll}
							onChange={value => this.props.onPinChange(value)}
							useForAll={this.props.isSummaryOfSummaries}
						/>
					</div>
				</div>
			</header>
		);
	}
	
	renderDataTableColumns(data){
		if(typeof data == "number" || typeof data == "string"){
			return (<td>{data}</td>);
		}
		else if(data.value !== null && data.value !== undefined){
			return (<td>{data.value}</td>);
		}
		else{
			return [
				<td key={"sum" + Date.now()}>{data.sum}</td>,
				<td key={"avg" + Date.now()}>{data.avg}</td>,
				<td key={"max" + Date.now()}>{data.max}</td>,
				<td key={"min" + Date.now()}>{data.min}</td>
			];
		}
	}
	
	renderTableRow(dataType, label){
		const data = this.props.summary[dataType]; 
		
		if(data !== null && data !== undefined){
			return(
				<tr className={this.getRowDataClassName(dataType)}>
					<td
						title={lang.CLICK_HERE_TO_FIX_IT}
						onClick={evt => this.handleDataClick(evt, dataType)}
					>{label}</td>
					
					{this.renderDataTableColumns(data)}
				</tr>
			);
		}
		else{
			return null;
		}
	}
	
	renderCardBody() {
		return (
			<table className={classnames({"Hidden": !this.isBodyShown()})}>
				{!this.props.isSummaryOfSummaries ? (
					<thead>
						<tr>
							<td></td>
							<td>{lang.SUM}</td>
							<td>{lang.AVG}</td>
							<td>{lang.MAX}</td>
							<td>{lang.MIN}</td>
						</tr>
					</thead>
				) : null}
				<tbody>
					{this.renderTableRow("timeDiff", lang.STAY_TIME)}
					{this.renderTableRow("totalVehicleDistanceDiff", lang.DISTANCE_TRAVELED_WITHIN_POI)}
					{this.renderTableRow("speed", lang.SPEED)}
					{this.renderTableRow("ignitionTime", lang.IGNITION_TIME)}
					{this.renderTableRow("nonIgnitionTime", lang.NON_IGNITION_TIME)}
					{this.renderTableRow("starts", lang.NUMBER_OF_STARTS)}
					{this.renderTableRow("stops", lang.NUMBER_OF_STOPS)}
					{this.renderTableRow("sectionCount", lang.NUMBER_OF_SECTIONS)}
					{this.renderTableRow("arrivals", lang.NUMBER_OF_ARRIVALS)}
					{this.renderTableRow("departures", lang.NUMBER_OF_DEPARTURES)}
				</tbody>
			</table>
		);
	}
	
	renderCardFooter() {
		return (
			<footer
				onClick={evt => {evt.stopPropagation(); this.toggle();}}
			>
				&bull;&bull;&bull;
			</footer>
		);
	}
	
	render() {
		return (
			<Card
				className="SummaryCard"
				onClick={() => this.props.onClick()}
			>
				{this.renderCardHeader()}
				{this.renderCardBody()}
				{this.renderCardFooter()}
			</Card>
		);
	}
	
}

SummaryCard.propTypes = {
	summary:				React.PropTypes.object,
	fixedData:				React.PropTypes.arrayOf(React.PropTypes.string),
	onClick:				React.PropTypes.func,
	onPinChange:			React.PropTypes.func,
	onFixData:				React.PropTypes.func,
	isSummaryOfSummaries:	React.PropTypes.bool,
	pinned:					React.PropTypes.bool,
	pinnedAll:				React.PropTypes.bool
};

SummaryCard.defaultProps = {
	summary:				null,
	fixedData:				[],
	onClick:				() => {},
	onPinChange:			value => {},
	onFixData:				which => {},
	isSummaryOfSummaries:	false,
	pinned:					false,
	pinnedAll:				false
};


// WEBPACK FOOTER //
// ./src/view/VehiclePOICrossingsSummaries/SummaryCard/SummaryCard.jsx